import { Map } from 'immutable';

import type { LiveStreamTypesKeys } from 'app/modules/LiveStream/types';

export type MatchStreamingAttributes = {
  streaming: {
    type: LiveStreamTypesKeys;
    payload: {
      url?: string;
      key?: string;
    };
  };
};

export const isStreamingInLiveMatches = (
  attributes: unknown,
): attributes is MatchStreamingAttributes => {
  return Map.isMap(attributes) && attributes.has('streaming');
};
